import {
  createApp,
  deleteApp,
  getAppById,
  getAppsForCurrentCustomer,
  updateApp,
} from "@/services/apps.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

const QUERY_KEY = ["pylo-apps"];
export const useApps = () => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn: getAppsForCurrentCustomer,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEY,
    });
  }, [queryClient]);

  const { mutate: createAppMutation, mutateAsync: createAppMutationAsync } = useMutation({
    mutationFn: createApp,
    onSuccess: () => {
      invalidateQuery();
    },
  });

  const { mutate: deleteAppMutation, mutateAsync: deleteAppMutationAsync } = useMutation({
    mutationFn: deleteApp,
    onSuccess: () => {
      invalidateQuery();
    },
  });

  const { mutate: updateAppMutation, mutateAsync: updateAppMutationAsync } = useMutation({
    mutationFn: updateApp,
    onSuccess: () => {
      invalidateQuery();
    },
  });

  return {
    ...query,
    invalidateQuery,
    createApp: createAppMutation,
    createAppAsync: createAppMutationAsync,
    deleteApp: deleteAppMutation,
    deleteAppAsync: deleteAppMutationAsync,
    updateApp: updateAppMutation,
    updateAppAsync: updateAppMutationAsync,
  };
};

export const useAppById = (id: string) => {
  return useQuery({
    queryKey: ["app", id],
    queryFn: () => getAppById({ id }),
    enabled: !!id,
  });
};
